import React, {useEffect, useState, useCallback} from "react";
import {
    Chart as ChartJS,
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend,
} from 'chart.js';
import { Bar } from 'react-chartjs-2';
import {getHoursPerWeek} from "../../utilities/report/getHoursPerWeekApi";
import keycloak from "../../Keycloak";


ChartJS.register(
    CategoryScale,
    LinearScale,
    BarElement,
    Title,
    Tooltip,
    Legend
);

export const options = {
    responsive: true,
    plugins: {
        legend: {
            position: 'top',
        },
        title: {
            display: true,
            text: 'Billable Hours to Available',
        },
    },
};



const BillableHours = () =>{

    const [hoursPerWeekDetails, setHoursPerWeekDetails] = useState([]);

    const callGetHoursPerWeek = useCallback(()=>{
        getHoursPerWeek(keycloak.token)
            .then((hoursPerWeek) => {
                setHoursPerWeekDetails(hoursPerWeek)
            })
            .catch((e)=>{
                console.log(e.message())
            })
    },[setHoursPerWeekDetails])

    useEffect(() => {
        callGetHoursPerWeek();
    }, [callGetHoursPerWeek]);

    const labels = [];
    const billableHours=[];
    const availableHours=[];

    hoursPerWeekDetails.forEach((item, index)=>{
        labels.push(item.weekNumber);
        billableHours.push(item.billableHours)
        availableHours.push(750);
    })


    const data = {
        labels,
        datasets: [
            {
                label: 'Billable Hours',
                data: billableHours,
                backgroundColor: 'rgba(255, 99, 132, 0.5)',
            },
            {
                label: 'Available hours',
                data: availableHours,
                backgroundColor: 'rgba(53, 162, 235, 0.5)',
            },
        ],
    };

    return (
        <div className="OuterMostDiv" data-testid='OuterMostDiv'>
            <div data-testid='InnerDiv' style={{ overflow: "hidden !important", marginLeft: "10%" , width: '70%'}}>
                <div>
                    <h1 data-testid='ClientHeading' style={{ top: '18%', left: '25%', position: 'absolute', fontFamily: 'poppins', fontWeight: '42px' }}>Billable Hours
                    </h1>
                    <div id="billableHoursChart" style={{ top: '30%', left: '25%', position: 'absolute', fontFamily: 'poppins' ,width:'700px'}} >
                        <Bar options={options} data={data} />
                    </div>
                </div>
            </div>
        </div>
            )
}

export default BillableHours